import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  IPassengerDeleteModalPayload,
  PassengerDeleteResultEnum,
  RideStationPanelMode,
} from "@ryde/shared";

import { ModalFooterStyled, MuiButton } from "../../controls";

interface IPassengerDeleteBookingChoiceFooterProps {
  confirmData: IPassengerDeleteModalPayload;
  onResult: (result: PassengerDeleteResultEnum) => () => void;
}

// Default footer: lets the user choose what happens to the booking when a
// passenger is removed — cancel the booking, or rebook it (keep as NEW).
export const PassengerDeleteBookingChoiceFooter: FC<
  IPassengerDeleteBookingChoiceFooterProps
> = ({ confirmData, onResult }) => {
  const { t } = useTranslation();

  const isRideEdit = Boolean(confirmData.ride?.id);
  const isGridPanel = confirmData.mode === RideStationPanelMode.GRID_PANEL;

  const removeCompletelyButtonTitle = isRideEdit
    ? t(`ride.cancelBookings`)
    : t(`general.OK`);

  return (
    <ModalFooterStyled>
      {(!isRideEdit || isGridPanel) && (
        <MuiButton
          muiStyle={"primary"}
          muiVariant={"outlined"}
          onClick={onResult(PassengerDeleteResultEnum.NoAction)}
          e2eData="cancel-modal-button"
        >
          {t(`general.CANCEL`)}
        </MuiButton>
      )}

      <MuiButton
        muiVariant={"outlined"}
        muiStyle={"warning"}
        onClick={onResult(PassengerDeleteResultEnum.CancelBooking)}
        e2eData="remove-completely-booking-button"
      >
        {removeCompletelyButtonTitle}
      </MuiButton>

      {isRideEdit && (
        <MuiButton
          onClick={onResult(PassengerDeleteResultEnum.NewBooking)}
          e2eData="ok-booking-button"
        >
          {t(`general.REBOOK`)}
        </MuiButton>
      )}
    </ModalFooterStyled>
  );
};
